import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Breadcrumb, BackdropCircular} from 'components';
import {
  Card,
  Badge,
  Button,
  Tab,
  Tabs
} from '@material-ui/core';
import { Formik } from 'formik';
import {
  getHomepagePremiumCTAConfigsApi,
  saveHomepagePremiumCTAConfigsApi,
  getStoreCategoriesApi,
  getAssetManagerCategoryTagsApi
} from 'api';
import PremiumCTAGeneral from './PremiumCTAGeneral';
import PremiumCTAItem from './PremiumCTAItem';
import { validationSchema } from './validation';


const ctaTabs = [
  'General',
  'First CTA Item',
  'Second CTA Item',
  'Third CTA Item',
  'Fourth CTA Item'
];

const PremiumCTABlock = () => {
  const dispatch = useDispatch();
  const [tabIndex, setTabIndex] = useState(0);

  const {
    homepagePremiumCTAConfigs,
    loadingHomepagePremiumCTAConfigs,
    homepagePremiumCTAConfigsToUpdate,
    savingHomepagePremiumCTAConfigs
  } = useSelector((state) => state.store_configs);
  const {
    storeActiveCategories,
  } = useSelector((state) => state.categories);
  const {
    assetCategoryTags,
    loadingAssetCategoryTags
  } = useSelector((state) => state.asset_manager);

  const loading = loadingHomepagePremiumCTAConfigs
    || savingHomepagePremiumCTAConfigs
    || loadingAssetCategoryTags;

  useEffect(() => {
    if (!Object.keys(homepagePremiumCTAConfigs['general']).length) {
      getHomepagePremiumCTAConfigsApi({dispatch});
    }

    if (!storeActiveCategories.length) {
      getStoreCategoriesApi({dispatch, checkStoreType: false});
    }

    if (!assetCategoryTags.length) {
      getAssetManagerCategoryTagsApi({dispatch, categoryName: 'Storebuild-automaton'});
    }
  }, []);

  const handleTabChange = (e, value) => {
    setTabIndex(value);
  };

  const setTabLabel = (tabName, errors) => {
    if (
      tabName === ctaTabs[1] &&
      (errors?.first)
    ) {
      return (
        <Badge badgeContent={'!'} color="error">
          {tabName}
        </Badge>
      );
    }

    if (
      tabName === ctaTabs[2] &&
      (errors?.second)
    ) {
      return (
        <Badge badgeContent={'!'} color="error">
          {tabName}
        </Badge>
      );
    }

    if (
      tabName === ctaTabs[3] &&
      (errors?.third)
    ) {
      return (
        <Badge badgeContent={'!'} color="error">
          {tabName}
        </Badge>
      );
    }

    if (
      tabName === ctaTabs[4] &&
      (errors?.fourth)
    ) {
      return (
        <Badge badgeContent={'!'} color="error">
          {tabName}
        </Badge>
      );
    }

    return tabName;
  };

  const handleSave = () => {
    saveHomepagePremiumCTAConfigsApi({dispatch, configs: homepagePremiumCTAConfigsToUpdate});
  };

  return (
    <div className="flex-grow flex-column relative h-full scroll-y">
      <Breadcrumb
        routeSegments={[
          { name: 'Settings', path: '/settings#go_live_requirements' },
          { name: 'UI Configurations', path: '/settings#UI_configurations' },
          { name: 'Homepage Settings', path: '/configurations/homepage'},
          { name: 'Premium Call To Action'}
        ]}
      />
      <div className="m-10">
        {!!Object.keys(homepagePremiumCTAConfigs['general']).length &&
        <Formik
          onSubmit={() => handleSave()}
          initialValues={{
            ...homepagePremiumCTAConfigs
          }}
          validationSchema={validationSchema}
        >
          {({
            values,
            errors,
            setFieldValue,
            handleSubmit
          }) => (
            <form autoComplete="off" onSubmit={handleSubmit}>
              <Card className="p-8">
                <Tabs
                  value={tabIndex}
                  onChange={handleTabChange}
                  indicatorColor="primary"
                  textColor="primary"
                  variant="scrollable"
                >
                  {ctaTabs.map((tab, idx) => (
                    <Tab
                      className="capitalize font-medium px-8"
                      key={`tab-${idx}`}
                      value={idx}
                      label={setTabLabel(tab, errors)}
                    />
                  ))}
                </Tabs>
                {tabIndex === 0 && <PremiumCTAGeneral values={values} setFieldValue={setFieldValue} />}
                {tabIndex === 1 && <PremiumCTAItem values={values.first} errors={errors} setFieldValue={setFieldValue} type="first" />}
                {tabIndex === 2 && <PremiumCTAItem values={values.second} errors={errors} setFieldValue={setFieldValue} type="second" />}
                {tabIndex === 3 && <PremiumCTAItem values={values.third} errors={errors} setFieldValue={setFieldValue} type="third" />}
                {tabIndex === 4 && <PremiumCTAItem values={values.fourth} errors={errors} setFieldValue={setFieldValue} type="fourth" />}
              </Card>
              <div className="flex justify-end">
                <Button
                  variant="contained"
                  color="primary"
                  className="my-10"
                  onClick={handleSave}
                  disabled={!!Object.keys(errors).length}
                >
                  Save Configurations
                </Button>
              </div>
            </form>
          )}
        </Formik>
        }
      </div>
      <BackdropCircular loading={loading} />
    </div>
  );
};

export default PremiumCTABlock;
